import { useState } from "react";
import { FormattedMessage } from "react-intl";
import iconPhone from "../../assets/images/icons/ball-phone.svg";
import LoadOutCheckbox from "../../components/fragments/loadOutCheckbox";
import ThreeModalActions from "../../components/fragments/threeModalActions";
import {
  DisplayBlock,
  TableLineResponsive,
  TableLineResponsiveHeader,
} from "../../styles/common";
import { TableStatus, AddressContainer, AddressLine, CodeContainer, DevicesLineResponsiveContainer } from "./style";

export default function ListItem({
  listData,
  modalObject,
  setModalObject,
  updateData,
  deleteData,
  setAddEditRegister,
  setIdEditRegister,
  setCheckID,
}) {
  const [lineActionsDropdown, setLineActionsDropdown] = useState(false);

  function handleOnChange() {
    setCheckID(listData.id, !listData.active);
  }

  return (
    <>
      <TableLineResponsive>
        <TableLineResponsiveHeader>
          <AddressLine>
            <LoadOutCheckbox
              value={listData.active}
              onChange={handleOnChange}
            />
            <AddressContainer>
              <img src={iconPhone} alt="Icon Phone" />
              <DisplayBlock>
                <h5>{listData.name}</h5>
                <TableStatus type={listData.status === 1 ? "Active" : ""}>
                  <figure />
                  <span>{listData.status === 0 ? "Inactive" : "Active"}</span>
                </TableStatus>
              </DisplayBlock>
            </AddressContainer>
          </AddressLine>
          <ThreeModalActions
            openModal={lineActionsDropdown}
            setOpenModal={setLineActionsDropdown}
            editAction={async () => {
              setAddEditRegister(true);
              setIdEditRegister(listData.id);
              setLineActionsDropdown(false);
              await updateData(listData.id)
            }}
            deleteAction={() => {
              setLineActionsDropdown(false);
              setModalObject({
                type: "alert",
                buttonLabel: "Delete",
                open: true,
                title: "Confirm delete",
                desc: "Are you sure you want to delete this item?",
                action: () => {
                  deleteData(listData.id);
                  setModalObject({
                    ...modalObject,
                    open: false,
                  });
                }
              });
            }}
          />
        </TableLineResponsiveHeader>
        <DevicesLineResponsiveContainer>
          <CodeContainer>
            <h6>
              <FormattedMessage id="tabela.phone" />
            </h6>
            <p>{listData.phone}</p>
          </CodeContainer>
          <CodeContainer>
            <h6>
              <FormattedMessage id="tabela.company" />
            </h6>
            <p>{listData.company}</p>
          </CodeContainer>
        </DevicesLineResponsiveContainer>
      </TableLineResponsive>
      <tr>
        <td>
          <LoadOutCheckbox
            value={listData.active}
            onChange={handleOnChange}
            label={listData.name}
          />
        </td>
        <td>
          <span>{listData.phone}</span>
        </td>
        <td>
          <span>{listData.company}</span>
        </td>
        <td>
          <TableStatus type={listData.status === 1 ? "Active" : ""}>
            <figure />
            <span>{listData.status === 0 ? "Inactive" : "Active"}</span>
          </TableStatus>
        </td>
        <td className="d-flex justify-content-end align-items-center">
          <ThreeModalActions
            openModal={lineActionsDropdown}
            setOpenModal={setLineActionsDropdown}
            editAction={async () => {
              setAddEditRegister(true);
              setIdEditRegister(listData.id);
              setLineActionsDropdown(false);
              await updateData(listData.id)
            }}
            deleteAction={() => {
              setLineActionsDropdown(false);
              setModalObject({
                type: "alert",
                buttonLabel: "Delete",
                open: true,
                title: "Confirm delete",
                desc: "Are you sure you want to delete this item?",
                action: () => {
                  deleteData(listData.id);
                  setModalObject({
                    ...modalObject,
                    open: false,
                  });
                }
              });
            }}
          />
        </td>
      </tr>
    </>
  );
}
